var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "window-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Оконные проёмы")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-step-two-img-container" }, [
        _c("img", {
          staticClass: "sidebar-step-two-img",
          attrs: { src: _vm.urlForStatic("/img/window_outline.svg") }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-text-area" }, [
        _vm._v(
          "Если вам нужно настроить выделяемую зону так, чтобы она более точно соответствовала существующей поверхности, увеличьте количество точек по периметру и, перетаскивая их, редактируйте поверхность."
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-text-area" }, [
      _vm._v("Обведите контуром плоскость "),
      _c("span", { staticClass: "red-text bold-text" }, [
        _vm._v("оконного проёма")
      ]),
      _vm._v(
        ", поочерёдно расставляя точки, соответствующие углам плоскости на изображении в рабочей области. Плоскость будет считаться завершенной, если замкнуть контур."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }